import client from '@/services/';
import Vue from 'vue';
import router from '@/routes';

const state = () => ({
    current: {},
    profile: {},
    logged: !!Vue.$cookies.get('OECCAtoken'),
    out: {},
});

const getters = {
    user: state => state.current,
    profile: state => state.profile,
    connected: state => state.logged,
    out: state => state.out,
};

const mutations = {
    SET_CONNECTED: (state, obj) => {
        state.current = obj;
    },
    SET_PROFILE: (state, obj) => {
        state.profile = obj;
    },
    SET_STATUS: (state, obj) => {
        state.logged = obj != null;
    },
    SET_OUT: (state, obj) => {
        state.out = obj; 
    },
};

const actions = {
    signin: async (cxt, obj = {}) => {
        return client.post('/api/auth/signin', obj).then(({ data }) => {
            cxt.commit("SET_CONNECTED", data);
            return data;
        });
    },
    
    // Nouvelle action pour gérer la redirection après connexion
    handlePostLoginRedirection: ({ commit }, userData) => {
        const userRole = userData.role?.libelle;
        
        // Vérifier s'il y a une route prévue (intended route)
        const intendedRoute = localStorage.getItem('intendedRoute');
        if (intendedRoute) {
            try {
                const route = JSON.parse(intendedRoute);
                // Vérifier que la route n'est pas trop ancienne (ex: 1 heure)
                const oneHour = 60 * 60 * 1000;
                if (Date.now() - route.timestamp < oneHour) {
                    localStorage.removeItem('intendedRoute');
                    router.push({
                        name: route.name,
                        params: route.params,
                        query: route.query
                    });
                    return;
                }
            } catch (error) {
                console.error('Erreur lors de la lecture de intendedRoute:', error);
            }
            localStorage.removeItem('intendedRoute');
        }
        
        // Vérifier s'il y a une dernière route visitée
        const lastVisitedRoute = localStorage.getItem('lastVisitedRoute');
        if (lastVisitedRoute) {
            try {
                const route = JSON.parse(lastVisitedRoute);
                // Vérifier que la route n'est pas trop ancienne (ex: 24 heures)
                const twentyFourHours = 24 * 60 * 60 * 1000;
                if (Date.now() - route.timestamp < twentyFourHours) {
                    router.push({
                        name: route.name,
                        params: route.params,
                        query: route.query
                    });
                    return;
                }
            } catch (error) {
                console.error('Erreur lors de la lecture de lastVisitedRoute:', error);
            }
        }
        
        // Redirection par défaut selon le rôle
        if (userRole === 'ADMIN' || userRole === 'ROLE_COMITE') {
            router.push({ name: 'dashboard' });
        } else if (userRole === 'STAGIAIRE') {
            router.push({ name: 'tableauDeBord' });
        } else {
            router.push({ name: 'dashboardOnly' });
        }
    },
    
    signup(cxt, payload) {
        return client.post('/api/auth/signup', payload).then(({ data }) => { return data; });
    },
    reset(cxt, payload) {
        return client.post('/api/auth/resetpassword', payload).then(({ data }) => { return data; });
    },
    profile(cxt) {
        return client.get('user/connected').then(({ data }) => {
            if (data) {
                cxt.commit("SET_PROFILE", data);
                localStorage.setItem('userConnectedProfile', JSON.stringify(data));
                return data;
            }
        });
    },
    editProfile(cxt, payload) {
        return client.put('user/update/profil/' + payload.id, payload).then(({ data }) => {
            cxt.commit("SET_PROFILE", data);
            return data;
        });
    },
    logout: ({ commit }) => new Promise(resolve => {
        // Nettoyer les routes sauvegardées lors de la déconnexion
        localStorage.removeItem('user');
        localStorage.removeItem('lastVisitedRoute');
        localStorage.removeItem('intendedRoute');
        Vue.$cookies.remove("OECCAtoken");
        commit("SET_CONNECTED", {});
        commit("SET_PROFILE", {});
        commit("SET_STATUS", null);
        resolve();
    }),
    resetPassword: async (cxt, obj = {}) => {
        return client.post('/user/resetFront', obj).then(({ data }) => {
            //cxt.commit("SET_OUT", data);
            return data;
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
